export default (node) => {
  /**
   * Data + elements
   */
  const allVariantDescriptions = node.querySelectorAll('[data-description]');
  const defaultDescription = node.querySelector('[data-default');

  /**
   * Functions
   */

  function updateDescriptions(variantId) {
    defaultDescription.classList.remove('hidden');
    allVariantDescriptions.forEach((description) => {
      if (description.dataset.description === variantId) {
        description.classList.remove('hidden');
        defaultDescription.classList.add('hidden');
      } else {
        description.classList.add('hidden');
      }
    });
  }
  /**
   * Init
   */
  const init = () => {
    // this function will show the correct description based on the variant selected
    document.addEventListener('variant:changed', (e) => {
      updateDescriptions(e.detail.variantId);
    });
  };

  init();
};
